import { Button, FormControl } from "@mui/material"
import { FormField, Option } from "./types"
import { useController, useFormContext } from "react-hook-form"
import { useCallback } from "react"

import styles from "./Forms.module.scss"
import { FormLabel } from "./FormLabel"
import { trackFormEvent } from "./utils"

export interface Props extends FormField {
  onButtonClick?: () => void
  options: Option[]
}

const ButtonsSelector = ({ label, name, rules, onButtonClick, options, tracking }: Props) => {
  const { control } = useFormContext()
  const controller = useController({ name, control, rules })

  const handleButtonClick = useCallback(
    (option: Option) => async () => {
      controller.field.onChange(option)
      onButtonClick?.()

      if (tracking?.shouldTrackValueChange) {
        await trackFormEvent("Form Value Provided", tracking, name, label)
      }
    },
    [controller.field, label, name, onButtonClick, tracking]
  )

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <div className={styles.buttonsSelector}>
        {options.map((option) => (
          <Button onClick={handleButtonClick(option)} variant="outlined" key={option.value}>
            {option.icon && <option.icon />} {option.label}
          </Button>
        ))}
      </div>
    </FormControl>
  )
}

export default ButtonsSelector
